module.exports = require("bluebird");


//////////////////
// WEBPACK FOOTER
// external "bluebird"
// module id = 25
// module chunks = 0